import type {PayloadAction} from '@reduxjs/toolkit';
import {createSlice} from '@reduxjs/toolkit';

interface State {
  scrollData: Record<string, number>;
}

interface UpdateScrollDataProps {
  key: string;
  scrollValue: number;
}
interface ResetStatesWithIdProps {
  ids: string[];
}

const initialState: State = {
  scrollData: {},
};

export const contextualMenuSlice = createSlice({
  name: 'contextualMenu',
  initialState,
  reducers: {
    updateScrollData: (state, action: PayloadAction<UpdateScrollDataProps>) => {
      state.scrollData[action.payload.key] = action.payload.scrollValue;
    },
    resetStatesWithId: (state, action: PayloadAction<ResetStatesWithIdProps>) => {
      action.payload.ids.forEach((id) => {
        state.scrollData[id] = 0;
      });
    },
  },
});

export const {updateScrollData, resetStatesWithId} = contextualMenuSlice.actions;
export const contextualMenuReducer = contextualMenuSlice.reducer;
